import { RootState } from "../store";
import { IAuthState } from "../types/state";

export const getUserStatus = (state: RootState): IAuthState["status"] => state.auth.status;

export const getUserErrorMsg = (state: RootState): IAuthState["errorMsg"] => state.auth.errorMsg;

export const getJwtFromStore = (state: RootState): IAuthState["jwt"] => state.auth.jwt;
